module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    staticClass: "scale-svg scale-full",
    attrs: {
      "width": "1280px",
      "height": "572px",
      "viewBox": "0 0 1280 572"
    }
  }, [_c('g', [_c('rect', {
    attrs: {
      "id": "table_2",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "fill": "#DFC8E4",
      "x": "-1",
      "y": "388",
      "width": "1282",
      "height": "185"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "table_1",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "fill": "#DFC8E4",
      "transform": "translate(640.000000, 379.500000) scale(-1, 1) translate(-640.000000, -379.500000) ",
      "x": "-1",
      "y": "371",
      "width": "1282",
      "height": "17"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M1181,158 L1181,316 L1181,316 C1181,321.522847 1176.52285,326 1171,326 L919,326 L919,326 C913.477153,326 909,321.522847 909,316 L909,158 L909,158 C909,152.477153 913.477153,148 919,148 L1171,148 L1171,148 C1176.52285,148 1181,152.477153 1181,158 Z",
      "id": "computer2_3",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "fill": "#DFC8E4",
      "transform": "translate(1045.000000, 237.000000) scale(-1, 1) translate(-1045.000000, -237.000000) "
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M983.021185,366.943684 L983.021185,371 L890.144512,371 L890.000928,363.472909 L890.000928,363.472909 C889.948262,360.711988 892.143736,358.431124 894.904658,358.378458 C895.007983,358.376487 895.111345,358.37772 895.214593,358.382155 L978.235759,361.94829 L978.235759,361.94829 C980.911261,362.063215 983.021185,364.265715 983.021185,366.943684 Z",
      "id": "computer2_2",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "fill": "#DFC8E4",
      "transform": "translate(936.510592, 364.688774) scale(-1, 1) translate(-936.510592, -364.688774) "
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M1079.81305,286 L1079.81305,357.153846 L1092,357.153846 L1092,357.153846 C1094.76142,357.153846 1097,359.392422 1097,362.153846 L1097,371 L994.123327,371 L993.968335,362.242322 L993.968335,362.242322 C993.919471,359.481331 996.118084,357.203493 998.879076,357.154629 C998.908565,357.154107 998.938058,357.153846 998.967552,357.153846 L1011.06523,357.153846 L1011.06523,286 L1079.81305,286 Z",
      "id": "computer2_1",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "fill": "#DFC8E4",
      "transform": "translate(1045.483768, 328.500000) scale(-1, 1) translate(-1045.483768, -328.500000) "
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M373,158 L373,316 L373,316 C373,321.522847 368.522847,326 363,326 L111,326 L111,326 C105.477153,326 101,321.522847 101,316 L101,158 L101,158 C101,152.477153 105.477153,148 111,148 L363,148 L363,148 C368.522847,148 373,152.477153 373,158 Z",
      "id": "computer1_3",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "fill": "#DFC8E4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M392,366.943684 L392,371 L299.123327,371 L298.979743,363.472909 L298.979743,363.472909 C298.927077,360.711988 301.122552,358.431124 303.883473,358.378458 C303.986798,358.376487 304.09016,358.37772 304.193409,358.382155 L387.214575,361.94829 L387.214575,361.94829 C389.890077,362.063215 392,364.265715 392,366.943684 Z",
      "id": "computer1_2",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "fill": "#DFC8E4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M270.845511,286 L270.845511,357.153846 L283.032464,357.153846 L283.032464,357.153846 C285.793888,357.153846 288.032464,359.392422 288.032464,362.153846 L288.032464,371 L185.155792,371 L185.000799,362.242322 L185.000799,362.242322 C184.951935,359.481331 187.150549,357.203493 189.91154,357.154629 C189.941029,357.154107 189.970522,357.153846 190.000016,357.153846 L202.097697,357.153846 L202.097697,286 L270.845511,286 Z",
      "id": "computer1_1",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "fill": "#DFC8E4"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-055ee782","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/module_6/svg/computerLabFront.vue
// module id = 952
// module chunks = 1